// extracted by mini-css-extract-plugin
export default {"footer":"StickyFooter_footer__lt94f","buttons":"StickyFooter_buttons__H3R6+"};